// Angular Imports
import {
	BrowserModule
} from '@angular/platform-browser';
import {
	NgModule,
	enableProdMode
} from '@angular/core';
enableProdMode();
import {
	NgClass,
	Location,
	LocationStrategy,
	HashLocationStrategy
} from '@angular/common';
import {
	RouterModule,
	Routes
} from '@angular/router';
import {
	FormsModule,
	ReactiveFormsModule
} from '@angular/forms';
import {
	HttpModule
} from '@angular/http';
// Bootstrap 3 Imports
import {
	TabsModule
} from 'ngx-bootstrap/tabs';
import {
	CollapseModule
} from 'ngx-bootstrap/collapse';
import {
	ButtonsModule
} from 'ngx-bootstrap/buttons';
import {
	BsDropdownModule
} from 'ngx-bootstrap/dropdown';
// App Imports

import {
	AppComponent
} from './components/app.component';
import {
	HomeComponent
} from './components/home.component';
import {
	ServicesComponent
} from './components/services.component';
import {
	AboutUsComponent
} from './components/about-us.component';
import {
	ContactUsComponent
} from './components/contact-us.component';
import {
	ReferAFriendComponent
} from './components/refer-a-friend.component';
import {
	ContactCompleteComponent
} from './components/contact-complete.component';
import {
	ContactErrorComponent
} from './components/contact-error.component';
import {
	ReferCompleteComponent
} from './components/refer-complete.component';
import {
	ReferErrorComponent
} from './components/refer-error.component';
import {
	FourOhFourComponent
} from './components/four-oh-four.component';
import {
	HeroesComponent
} from './components/heroes.component';


import {
	AutoGrowDirective
} from './directives/auto-grow.directive';
import {
	SetFocusDirective
} from './directives/set-focus.directive';

const appRoutes: Routes = [
	{
		path: 'services',
		component: ServicesComponent
	},
	{
		path: 'about-us',
		component: AboutUsComponent
	},
	{
		path: 'contact-us',
		component: ContactUsComponent
	},
	{
		path: 'home',
		component: HomeComponent
	},
	{
		path: 'refer-a-friend',
		component: ReferAFriendComponent
	},
	{
		path: 'contact-complete',
		component: ContactCompleteComponent
	},
	{
		path: 'contact-error',
		component: ContactErrorComponent
	},
	{
		path: 'refer-complete',
		component: ReferCompleteComponent
	},
	{
		path: 'refer-error',
		component: ReferErrorComponent
	},
	{
		path: 'heroes',
		component: HeroesComponent
	},
	{
		path: '',
		component: HomeComponent
	},
	{
		path: '**',
		component: FourOhFourComponent
	}
]

@NgModule({
	declarations: [
		AppComponent,
		HomeComponent,
		ServicesComponent,
		AboutUsComponent,
		ContactUsComponent,
		ReferAFriendComponent,
		ContactCompleteComponent,
		ContactErrorComponent,
		ReferCompleteComponent,
		ReferErrorComponent,
		FourOhFourComponent,
		HeroesComponent,
		SetFocusDirective,
		AutoGrowDirective
	],
	imports: [
		BrowserModule,
		FormsModule,
		ReactiveFormsModule,
		HttpModule,
		TabsModule.forRoot(),
		ButtonsModule.forRoot(),
		CollapseModule.forRoot(),
		BsDropdownModule.forRoot(),
		RouterModule.forRoot(
		appRoutes
		)
	],
	providers: [Location, {provide: LocationStrategy, useClass:HashLocationStrategy}],
	bootstrap: [AppComponent]
})
export class AppModule { 
	constructor(){
	}
}



// WEBPACK FOOTER //
// D:/Projects/GitHub/gvrogers/src/app/app.module.ts